/* global confetti */

document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.sar61-countdown[data-countdown]');
    blocks.forEach(block => {
        const timestamp = parseInt(block.dataset.countdown, 10);
        const countdownKey = `countdown-exploded-${timestamp}`;

        if (isNaN(timestamp)) return;
        const target = timestamp * 1000;

        const daysElUnit = block.querySelector('.unit-days');
        const hoursElUnit = block.querySelector('.unit-hours');
        const minsElUnit = block.querySelector('.unit-minutes');
        const secsElUnit = block.querySelector('.unit-seconds');
        const separators = block.querySelectorAll('.separator');

        const daysEl = daysElUnit.querySelector('.days');
        const hoursEl = hoursElUnit.querySelector('.hours');
        const minsEl = minsElUnit.querySelector('.minutes');
        const secsEl = secsElUnit.querySelector('.seconds');

        const finish = () => {
            const alreadyExploded = localStorage.getItem(countdownKey) === '1';

            if (!alreadyExploded && typeof confetti === 'function') {
                confetti({ particleCount: 200, spread: 100, origin: { y: 0.6 } });
                localStorage.setItem(countdownKey, '1');
                const event = new CustomEvent('countdown:finished', { detail: { block } });
                document.dispatchEvent(event);
            }

            block.querySelector('.sar61-countdown__timer')?.classList.add('countdown-hidden');
            block.querySelector('.sar61-countdown__title')?.classList.add('countdown-hidden');
            block.querySelector('.sar61-countdown__reveal')?.classList.remove('countdown-hidden');
        };

        const updateVisibility = () => {
            const now = Date.now();
            const diff = target - now;

            const showDays = diff > 86400000;
            const showSecs = diff < 86400000;

            daysElUnit.style.display = showDays ? 'flex' : 'none';
            secsElUnit.style.display = showSecs ? 'flex' : 'none';

            const units = [daysElUnit, hoursElUnit, minsElUnit, secsElUnit];
            const sepArray = Array.from(separators);
            sepArray.forEach((sep, i) => {
                const prev = units[i];
                const next = units[i + 1];
                const prevVisible = prev?.style.display !== 'none';
                const nextVisible = next?.style.display !== 'none';
                sep.style.display = prevVisible && nextVisible ? 'inline-block' : 'none';
            });
        };

        const tick = () => {
            const now = Date.now();
            const diff = target - now;

            updateVisibility();

            if (diff <= 0) {
                daysEl.textContent = '0';
                hoursEl.textContent = '0';
                minsEl.textContent = '0';
                secsEl.textContent = '0';
                finish();
                return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const mins = Math.floor((diff / (1000 * 60)) % 60);
            const secs = Math.floor((diff / 1000) % 60);

            daysEl.textContent = String(days);
            hoursEl.textContent = String(hours);
            minsEl.textContent = String(mins);
            secsEl.textContent = String(secs);

            requestAnimationFrame(tick);
        };

        // Immediate check if countdown is already over
        if (Date.now() >= target) {
            finish();
        } else {
            tick();
        }

        // Reveal block after init to prevent flash
        block.setAttribute('data-ready', 'true');
    });
});
